import ajax from '@/utils/ajax';
import { isApp } from '@/utils/tools';
import { callKeXieAppFunc, isKeXieApp } from './ccwork';

const TYPE = {
  wechatMessage: 1,
  wechatTimeline: 2,
  app: 3,
  dingDing: 4,
};

type Type = (typeof TYPE)[keyof typeof TYPE];

interface Config {
  link?: string;
  title?: string;
  desc?: string;
  img?: string;
  isShareImage?: number;
  successCallback?: (type: Type) => void;
}

interface Share extends Required<Omit<Config, 'successCallback'>> {
  successCallback?: (type: Type) => void;
}

// 微信配置是否好了
let wxIsReady = false;

// 分享配置
const share: Share = {
  link: window.location.href,
  title: '',
  desc: '',
  img: '',
  isShareImage: 0,
  successCallback: undefined,
};

// 设置分享配置
export function setShareConfig(config: Config) {
  share.link = config?.link ?? window.location.href;
  share.title = config?.title ?? '';
  share.desc = config?.desc ?? '';
  share.img = config?.img ?? '';
  share.isShareImage = config?.isShareImage ?? 0;
  share.successCallback = config?.successCallback;
  setAppShareConfig();
  // if (wxIsReady &&  router.options.mode === "hash") {
  //   setWXShareConfig();
  // } else {
  initWXConfig();
  // }
  setDingDingShareConfig();
}

/**
 * 调起APP的分享
 * @param {*} config 分享配置
 */
export function launchAppShare() {
  if (isApp()) {
    window.appShareCallbackFunction = () => {
      share.successCallback?.(TYPE.app);
    };
    window.sma.share({
      link: share.link,
      title: share.title,
      desc: share.desc,
      imgUrl: share.img,
      async: true,
      isShareImage: share.isShareImage.toString(),
      callbackId: 'appShare',
      callbackFunction: 'window.appShareCallbackFunction',
    });
  } else if (isKeXieApp()) {
    callKeXieAppFunc('ccworkShare', {
      shareUrl: share.link,
      shareTitle: share.title,
      shareDes: share.desc,
      imgUrl: share.img,
    });
  }
  // TODO: 微信分享统一处理
}

/**
 * 设置App分享
 */

function setAppShareConfig() {
  if (isApp()) {
    window.appShareCallbackFunction = () => {
      share.successCallback?.(TYPE.app);
    };
    if (window.sma.platform.harmony) return;
    window.sma.setShareInfo({
      link: share.link,
      title: share.title,
      desc: share.desc,
      imgUrl: share.img,
      async: true,
      isShareImage: share.isShareImage.toString(),
      callbackId: 'appShare',
      callbackFunction: 'window.appShareCallbackFunction',
    });
  }
}

/**
 * 初始化微信配置
 * @returns
 */
async function initWXConfig() {
  const ua = navigator.userAgent.toLowerCase();
  if (!/MicroMessenger/i.test(ua)) {
    return;
  }
  try {
    const href = location.href.split('#')[0];
    const url = new URL(href);
    const spm = url.searchParams.get('spm');
    const res = await ajax.get('/wx/getWxToken', {
      addSignature: false,
      params: {
        url: spm ? href : encodeURI(href),
        wxNum: 7,
      },
      addToken: false,
      baseURL: '/h5-api',
    });
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: res.data.appId, // 必填，公众号的唯一标识
      timestamp: res.data.timestamp, // 必填，生成签名的时间戳
      nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
      signature: res.data.signature, // 必填，签名
      jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline'], // 必填，需要使用的JS接口列表
    });
    wx.ready(() => {
      wxIsReady = true;
      setWXShareConfig();
    });
  } catch (error) {
    console.error('获取微信分享配置失败', error);
  }
}

/**
 * 设置微信分享
 */
function setWXShareConfig() {
  const ua = navigator.userAgent.toLowerCase();
  if (!/MicroMessenger/i.test(ua)) {
    return;
  }
  if (!wxIsReady) {
    console.log('微信未初始化');
    return;
  }
  // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
  wx.onMenuShareAppMessage({
    title: share.title, // 分享标题
    desc: share.desc, // 分享描述
    link: share.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: share.img, // 分享图标
    //trigger
    trigger: function (res) {
      console.log(res, '分享成功进行回调。。。。。');
      // 分享成功
      share.successCallback?.(TYPE.wechatMessage);
    },
  });
  // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
  wx.onMenuShareTimeline({
    title: share.title, // 分享标题
    link: share.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: share.img, // 分享图标
    //trigger
    trigger: function (res) {
      console.log(res, '分享成功进行回调。。。。。');
      // 分享成功
      share.successCallback?.(TYPE.wechatTimeline);
    },
  });
}

/**
 * 设置钉钉分享
 */
function setDingDingShareConfig() {
  // 钉钉分享
  if (!dd.version) {
    return;
  }
  dd.ready(function () {
    dd.biz.navigation.setRight({
      show: true,
      control: true,
      showIcon: true,
      onSuccess: function () {
        dd.biz.util.share({
          type: 0, //分享类型，0:全部组件 默认；1:只能分享到钉钉；2:不能分享，只有刷新按钮
          url: share.link,
          title: share.title,
          content: share.desc,
          image: share.img,
          onSuccess: function () {
            share.successCallback?.(TYPE.dingDing);
          },
          onFail: function () {},
        });
      },
    });
  });
}
